<div>

  <!-- Promotion -->
  <div class="section-promotion" *ngIf="promotionCode">
    <div class="promotion">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="promotion-text" [ngSwitch]="promotionCode">
              <span *ngSwitchCase="'FRIEND'">Congratulations! Your friend has given you a discount 🎉</span>
              <span *ngSwitchCase="'TRIAL7'">Your first 7 days are commitment free with any Croissant membership 🎉</span>
              <span *ngSwitchDefault>Congratulations! Your promotion has been applied. Aren't promotions awesome?</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br>

  <!-- Header -->
  <div class="section-header">
    <div class="container">
      <div class="row">
        <div class="col-6">
          <picture>
            <source srcset="/images/join/join-details/logo.webp" type="image/webp">
            <img src="/images/join/join-details/logo.png" height="30" alt="Croissant logo"/>
          </picture>
        </div>
        <div class="col-6">
          <div class="text-end">
            <p class="mt-2">Have an account?&nbsp;&nbsp;<a routerLink="/login">Sign in</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br/>

  <!-- Lead -->
  <div class="section-lead">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="text-center">
            <h1>Hi there, it's nice to meet you!</h1>
            <h4>Tell us a little about yourself to get started.</h4>

            <br/>
            <br/>
          </div>
        </div>

        <div class="col-12 col-lg-10 offset-lg-1">
          <div class="row">
            <div class="col-12 col-md-6">
              <form (ngSubmit)="submit()" ngNativeValidate>
                <div class="form-group">

                  <!-- Capitalize name -->
                  <label>Your name</label>
                  <div class="input-group input-group-lg">
                    <input type="text" name="fullName" [(ngModel)]="fullName" class="form-control" required>
                  </div>

                  <br/>

                  <label>Your email</label>
                  <div class="input-group input-group-lg">
                    <input type="email" name="email" [(ngModel)]="email" class="form-control" required>
                  </div>

                  <br/>

                  <label>Country</label>
                  <div class="input-group input-group-lg">
                    <select name="country" [(ngModel)]="countrySlug" class="form-select" required>
                      <option *ngFor="let country of countries" [value]="country.slug">{{ country.name }}</option>
                    </select>
                  </div>

                  <br/>

                  <label>{{ countrySlug === 'US' ? 'Zip code' : 'Postcode' }}</label>
                  <div class="input-group input-group-lg">
                    <input type="text" name="postalCode" [(ngModel)]="postalCode" class="form-control"/>
                  </div>

                  <br/>

                  <div class="text-end text-md-start">
                    <button class="btn btn-next" type="submit" [disabled]="submitted">Next</button>
                  </div>

                  <br/>
                  <br/>

                </div>
              </form>
            </div>
            <div class="col-12 col-md-6 hide-sm hide-md">
              <picture>
                <source srcset="/images/join/join-details/coworking.webp" type="image/webp">
                <img src="/images/join/join-details/coworking.png" class="img-responsive" alt="Coworking space illustration"/>
              </picture>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
